import { useQueryClient } from '@tanstack/react-query';
import { usePostHog } from 'posthog-js/react';


const useLogout = () => {
    const queryClient = useQueryClient();
    const posthog = usePostHog();
    const logout = async () => {
        localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
        posthog.reset();
        await queryClient.invalidateQueries();
        queryClient.clear();
        window.location.href = '/'; // redirect to home
    };

    return logout;
};

export default useLogout;